import styled from "styled-components";

export const ContactContainer = styled.div`
    height: 80vh;
    width: auto;
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    align-items: center;
    background: black;
    overflow: hidden;

    @media screen and (max-width: 1311px) {
    height: 80vh;
    }
`

export const ContactH2 = styled.h1`
    display: flex;
    color: white;
    font-size: 3rem;
    text-align: center;
    font-family: 'Gemunu Libre', sans-serif;
    @media screen and (max-width: 1311px) {
    font-size: 4vh;
    }
`

export const ContactSocial = styled.div`
    justify-items: center;
    align-items: center;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 50px;
    z-index: 5;       
    margin: 0 auto;
    transition: 1s ;
`
export const ContactP = styled.p`
    display: flex;
    color: white;
    font: 2rem;
    font-family: 'Gemunu Libre', sans-serif;
`

export const ContactArea = styled.textarea`
    width: 30vw;
    height: 20px;
    padding: 10px;
    outline: none;
    font: 20px;
    margin-top: 20px;
    border-radius: 5px;
    resize: none;
    transition: 0.5s;
    &:focus{
        transform: scale(1.2);
        transition: 0.5s;
    }
`

export const ContactImgWrap = styled.div`
position: relative;
display: flex;
height: fit-content;

overflow: hidden;
width: 100%;
align-items: center;
bottom: -200px;
`

export const ContactButton = styled.button`

height: 5vh;
width: 200px;
color: black;
background: white;
border-radius: 10px;
font-size: 2vh;
transition: 0.5s;
margin-top: 5vh;
margin-bottom: -5vh;
font-family: 'Gemunu Libre', sans-serif;

&:hover{
    transform: scale(1.2);
    transition: 0.5s;
}
`